import { stylesFactory } from '@orthly/ui-primitives';

export const useGenericTimelineActionStyles = stylesFactory(() => ({
    actionWrapper: {
        marginTop: `8px`,
    },
}));
